import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Requests Vehicle Groups to be unassigned from a specific Speed Coaching Profile
 * @param id The ID of the Speed Coaching Profile who is being unassigned from
 * @param vehicleGroupIds The IDs of the Vehicle Groups being unassigned
 * @returns Data object containing array of assigned Vehicle Group's IDs
 */
export function postSpeedCoachingVehicleGroupsUnassign(
  this: unknown,
  id: number,
  vehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .speedCoachingIdVehicleGroupsUnassignUrl(id),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            vehicleGroupIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({ vehicleGroupIds: z.array(z.number()) }),
      })
    )
  );
}
